import { Link } from "react-router-dom";

const MetaTrader4ContentThree = () => {
  return (
    <div className="how__work__platform">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="content-left">
              <h2>Trade Anywhere, Anytime with MetaTrader 4</h2>
              <p>
                MetaTrader 4 is not just limited to desktop trading. The
                platform is fully compatible with mobile and web terminals,
                allowing you to monitor your trades, analyze market trends, and
                execute positions from your iOS or Android devices. Stay
                connected to the global markets 24/7 with the same tools,
                indicators, and trading precision wherever you go. Its intuitive
                interface ensures you never miss a market opportunity, even
                while on the move. With seamless synchronization across all
                devices, your trading workflow remains uninterrupted and
                effortlessly efficient.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Access MT4 Anywhere
              </Link>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="thumb-right">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/platforms/meta_trader_4/meta_trader_4_02.png"
                }
                alt="computer images"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetaTrader4ContentThree;
